import FeatherIcons from '@expo/vector-icons/Feather'
import React from 'react'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { CustomIcons } from 'widgets/Icon/icons/custom'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import { ThemeColor } from 'utils/themes/types'

export const ActionIcon = ({
  icon,
  label,
  action,
  disabled,
  testID,
  zIndex,
  direction = 'column',
  color = 'textInverted',
  textColor,
  iconSize = 20,
  style,
}: {
  icon: keyof typeof FeatherIcons.glyphMap | keyof typeof CustomIcons
  label?: string
  disabled?: boolean
  action?: () => void
  testID?: string
  zIndex?: number
  direction?: 'row' | 'column'
  color?: ThemeColor
  textColor?: ThemeColor
  iconSize?: number
  style?: any
}) => {
  return (
    <Pressable style={{ zIndex, ...style }} disabled={disabled} onPress={action} testID={testID}>
      <Box flexDirection={direction} align='center'>
        <Icon name={icon} size={iconSize} color={color} />
        {label?.length ? (
          <>
            {direction === 'row' && <Box width={4} />}
            <Box margin={{ top: iconSize >= 24 ? 0 : 2 }}>
              <Text fontSize={iconSize >= 24 ? 'sm' : 'xs'} color={textColor ?? color}>
                {label}
              </Text>
            </Box>
          </>
        ) : null}
      </Box>
    </Pressable>
  )
}
